"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _antd = require("antd");

var _react = _interopRequireWildcard(require("react"));

var _config = _interopRequireDefault(require("../../../../config.json"));

var _axios = _interopRequireDefault(require("axios"));

var _icons = require("@ant-design/icons");

// import { useHistory } from 'react-router';
// import ErrorPage from '../../../error-views/errorPage'
var normFile = function normFile(e) {
  console.log('Upload event:', e);

  if (Array.isArray(e)) {
    return e;
  }

  return e && e.fileList;
};

var Student = function Student() {
  // const cl = localStorage.getItem("CL");
  var token = localStorage.getItem("token");

  var _useState = (0, _react.useState)(),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      apiError = _useState2[0],
      setapiError = _useState2[1];

  var _Form$useForm = _antd.Form.useForm(),
      _Form$useForm2 = (0, _slicedToArray2.default)(_Form$useForm, 1),
      form = _Form$useForm2[0];

  var _useState3 = (0, _react.useState)(),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      fileData = _useState4[0],
      setFileData = _useState4[1];

  var onFinish = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(values) {
      var url, files, csvData;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              url = _config.default.uploadStudent1;
              files = fileData;
              csvData = new FormData();
              csvData.append("file", files);

              _axios.default.post(url, csvData, {
                headers: {
                  'Authorization': token
                }
              }).then(function (resp) {
                if (resp.data.status === "error") setapiError(resp.data);else alert("import data successfully");
                console.log(resp.data);
              }, function (error) {
                if (error.response) setapiError(error.response);
              });

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onFinish(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  return apiError ? /*#__PURE__*/_react.default.createElement("h1", null, apiError.log) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_antd.Card, {
    title: "Upload Student Details file"
  }, /*#__PURE__*/_react.default.createElement(_antd.Form, {
    name: "basic",
    size: "small",
    wrapperCol: 4,
    form: form,
    onFinish: onFinish
  }, /*#__PURE__*/_react.default.createElement(_antd.Row, {
    gutter: 16
  }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    span: 24
  }, /*#__PURE__*/_react.default.createElement(_antd.Form.Item, {
    name: "upload",
    label: "Upload",
    valuePropName: "fileList",
    getValueFromEvent: normFile,
    onChange: function onChange(e) {
      return setFileData(e.target.files[0]);
    },
    rules: [{
      required: true,
      message: 'The field is required'
    }]
  }, /*#__PURE__*/_react.default.createElement(_antd.Upload, {
    name: "logo",
    action: "/upload.do",
    accept: ".csv",
    maxCount: 1
  }, /*#__PURE__*/_react.default.createElement(_antd.Button, null, /*#__PURE__*/_react.default.createElement(_icons.UploadOutlined, null), " Click to upload")))), /*#__PURE__*/_react.default.createElement(_antd.Col, {
    span: 24
  }, /*#__PURE__*/_react.default.createElement(_antd.Form.Item, {
    className: "text-right"
  }, /*#__PURE__*/_react.default.createElement(_antd.Button, {
    type: "primary",
    htmlType: "submit"
  }, "Submit")))))));
};

var _default = Student;
exports.default = _default;